import React from "react";
import {
  Layout,
  Card,
  Typography,
  Divider,
  Badge,
  Button,
  Row,
  Col,
  Tag,
} from "antd";
import { LeftOutlined, EditOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import CreateMaster from "./CreateMaster";

const { Content } = Layout;
const { Title, Text } = Typography;

const MasterDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [openEdit, setOpenEdit] = React.useState(false);
  const [editData, setEditData] = React.useState(null);

  const adData = location.state?.adData;

  if (!adData) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        No advertisement data found
      </div>
    );
  }

  return (
    <div style={{ padding: 24, background: "#f5f7fb", minHeight: "100vh" }}>

      {/* 🔥 Edit Modal */}
      <CreateMaster
        visible={openEdit}
        editdata={editData}
        onCancel={() => {
          setOpenEdit(false);
          setEditData(null);
        }}
        onSuccess={() => {
          setOpenEdit(false);
          setEditData(null);
          navigate(-1);
        }}
      />

      {/* 🔥 Header */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <Button
          icon={<LeftOutlined />}
          type="link"
          onClick={() => navigate(-1)}
        >
          Back
        </Button>

        {/* <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => {
            setEditData(adData);
            setOpenEdit(true);
          }}
        >
          Edit Ad
        </Button> */}
      </div>

      <Layout>
        <Content>

          <Row gutter={24}>
            {/* LEFT SIDE - DETAILS */}
            <Col xs={24} lg={16}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                }}
              >
                <Title level={3}>{adData.fld_ad_title}</Title>

                <Divider />

                <Title level={4}>📢 Description</Title>
                <Text type="secondary" style={{ fontSize: 15 }}>
                  {adData.fld_ad_description || "No description available"}
                </Text>

                <Divider />

                <Title level={4}>📌 Ad Information</Title>

                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Card style={{ borderRadius: 12 }}>
                      <Text strong>Ad ID</Text>
                      <div>{adData.fld_ad_id}</div>
                    </Card>
                  </Col>
                </Row>

                <Divider />

                <Title level={4}>📍 Display Settings</Title>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                    <Card style={{ borderRadius: 12 }}>
                      <Text strong>Screen</Text>
                      <div>{adData.fld_target_screen}</div>
                    </Card>
                  </Col>

                  <Col xs={24} md={12}>
                    <Card style={{ borderRadius: 12 }}>
                      <Text strong>Status</Text>
                      <div>
                        <Tag
                          color={
                            adData.fld_ad_status === "active"
                              ? "green"
                              : "red"
                          }
                        >
                          {adData.fld_ad_status}
                        </Tag>
                      </div>
                    </Card>
                  </Col>
                </Row>

                <Divider />

                <Title level={4}>📅 Schedule</Title>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                    <Card style={{ borderRadius: 12 }}>
                      <Text strong>Start Date</Text>
                      <div>{adData.fld_start_date}</div>
                    </Card>
                  </Col>

                  <Col xs={24} md={12}>
                    <Card style={{ borderRadius: 12 }}>
                      <Text strong>End Date</Text>
                      <div>{adData.fld_end_date}</div>
                    </Card>
                  </Col>
                </Row>
              </Card>
            </Col>

            {/* RIGHT SIDE - IMAGE */}
            <Col xs={24} lg={8}>
              <Card
                title="Advertisement Image"
                style={{
                  borderRadius: 16,
                  position: "sticky",
                  top: 20,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 500,
                    background: "#fafafa",
                    borderRadius: 12,
                    padding: 16,
                  }}
                >
                  <img
                    src={
                      adData.fld_image_path ||
                      "https://via.placeholder.com/400"
                    }
                    alt="Advertisement"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "700px",
                      objectFit: "contain",
                      borderRadius: 12,
                    }}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    </div>
  );
};

export default MasterDetails;